import { differenceInYears } from 'date-fns';

export const getAge = (birthDate: number): number => differenceInYears(new Date(), birthDate);
